import { Dispatch, SetStateAction } from 'react';
import { Link } from 'react-router-dom';
import useGetGeneralAppData from '../../../../../hooks/useGetGeneralAppData';
import { MappedVehicleType } from '../../types';
import { Container } from './styles';

interface ListHeaderInterface {
  entity: MappedVehicleType[];
  apiFetched: boolean;
  filteredEntity: MappedVehicleType[];
  linkPath: string;
  entityString: { singular: string, plural: string };
  setAllQrCodesModalShow: Dispatch<SetStateAction<boolean>>;
  hasVehicles: boolean;
}

export default function ListHeader({
  entity,
  apiFetched,
  filteredEntity,
  linkPath,
  entityString,
  setAllQrCodesModalShow,
  hasVehicles,
}: ListHeaderInterface) {
  const { permissions } = useGetGeneralAppData();
  const affreightmentsVehiclesPermissions = permissions.find((x) => x.codPag === 11);

  return (
    <Container doesListExists={Boolean(entity)} apiFetched={apiFetched}>
      {(entity && apiFetched) && (
        <strong>
          {filteredEntity.length}
          {' '}
          {filteredEntity.length === 1 ? entityString.singular : entityString.plural}
        </strong>
      )}
      <div className="actionButtons">
        {entity && apiFetched && hasVehicles && (
          <button type="button" onClick={() => setAllQrCodesModalShow(true)}>Qr Codes</button>
        )}
        {affreightmentsVehiclesPermissions?.incluir && (
          <Link to={linkPath}>Novo veículo</Link>
        )}
      </div>
    </Container>
  );
}
